import { render, staticRenderFns } from "./OutboundTransferDetails.template.vue?vue&type=template&id=635d067a&scoped=true&"
var script = {}
import style0 from "./OutboundTransferDetails.template.vue?vue&type=style&index=0&id=635d067a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d067a",
  null
  
)

export default component.exports